import { createQueryKeyStore } from '@lukemorales/query-key-factory'

import type { DisableKeyWhenMissingFlag } from '../helpers/utilities'
import type { FundSymbol } from '../products'

export const keys = createQueryKeyStore({
  limit_orders: {
    all: (args: {
      fund_symbol: FundSymbol
      wallet_address: CryptoAddress | DisableKeyWhenMissingFlag
    }) => [args],
    details: (details_args: { fund_symbol: FundSymbol }) => ({
      queryKey: [details_args],
      contextQueries: {
        paused: null,
        limits: null,
        tick_usage: (tick_args: { tick: number; price: number }) => [tick_args],
      },
    }),
  },
})
